import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

export type CreateTemplatePayload = FormData

type MutationResponse = {
  timestamp: string;
  statusCode: number;
  status: string;
  message: string;
  data: any;
};

export const useBulkContactUploadMutation = () => {
  const mutationFn = useGetMutationFn<CreateTemplatePayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while uploading WhatsApp Contacts',
    endpoint: '/api/admin/whatsapp/contacts/file',
    method: 'POST',
  });

  return useMutation<MutationResponse, Error, CreateTemplatePayload>({ mutationFn });
};
